import { render, staticRenderFns } from "./BannerInicio.vue?vue&type=template&id=b4d53946&scoped=true"
import script from "./BannerInicio.vue?vue&type=script&lang=js"
export * from "./BannerInicio.vue?vue&type=script&lang=js"
import style0 from "./BannerInicio.vue?vue&type=style&index=0&id=b4d53946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d53946",
  null
  
)

export default component.exports